export const minimalTextTitleSimilarity = {
  berryPunch: "Berry Punch",
  darjeelingSecondFlush: "Darjeeling Second Flush",
  volcanicWater: "Volcanic Water",
};

export const minimalTextTitleColor = {
  kiba: "Kiba",
};

export const allTextTitles: { [key: string]: string } = {
  ...minimalTextTitleColor,
  ...minimalTextTitleSimilarity,
};

export const netTextSurrounding = ["", " Net"];
